<input
  #rfqInputRef
  id="id-{{ index }}"
  [matAutocomplete]="auto"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (debounceValue)="onSearchRfq($event)"
  type="text"
  class="lum-input table__search-skus-input rfq-item-input"
  placeholder="Search SKU or Product Name..."
  matInput
  lumDebounceTime
  [value]="displayValue"
  [disabled]="disabled"
/>
<mat-autocomplete
  #auto="matAutocomplete"
  [panelWidth]="500"
  (optionSelected)="onSelectSku($event)"
  class="rfq-item-autocomplete"
  (lumInfiniteScroll)="onScrollPaginate()"
>
  <ng-container *ngIf="!(loadingRfqs$ | async); else loader">
    <mat-option
      *ngFor="let rfq of rfqs$ | async; trackBy: trackById"
      [value]="rfq"
      class="rfq-item-option"
    >
      <div class="rfq-item flex gap-4 w-100">
        <div class="flex align-items-center">
          <img [lumRfqThumbnailUrl]="rfq" alt="" class="lum-img lum-thumbnail" />
        </div>
        <div>
          <div>
            {{ rfq?.product_name }} [{{
              rfq?.sku ? rfq?.sku : rfq?.internal_sku || 'N/A'
            }}]
          </div>
          <small>
            {{ rfq?.product_name }}
          </small>
        </div>
      </div>
    </mat-option>
  </ng-container>

  <ng-template #loader>
    <mat-option>
      <div class="flex gap-4">
        <mat-progress-spinner
          class="progress-spinner mt-3"
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
        <small>Loading...</small>
      </div>
    </mat-option>
  </ng-template>
</mat-autocomplete>
